export default __webpack_public_path__ + "static/media/review-bg.b0e12f08.jpg";